import React from 'react';
import ReactDOM from 'react-dom';
import { NavLinkProps, NavLink } from 'react-router-dom';
import globalNav from '~/lib/store/GlobalNavStore';

type SideSubNavProps = {
    children: React.ReactNode;
};

export default class SideSubNav extends React.Component<SideSubNavProps> {
    el: HTMLDivElement;

    constructor(props: SideSubNavProps) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        globalNav.pushNav(this.el);
    }

    componentWillUnmount() {
        const popped = globalNav.popNav();
        if (popped !== this.el) console.error('unexpected nav element during pop');
    }

    render(): JSX.Element {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}

export class SideNavLink extends React.Component<NavLinkProps> {
    render() {
        const { onClick, ...rest } = this.props;
        return (
            <NavLink
                onClick={(e) => {
                    onClick?.(e);
                    globalNav.hideNav();
                }}
                {...rest}
            />
        );
    }
}
